import { ValidatieParameter } from './validatie-parameter';
import { Antwoord } from './antwoord';
import { Vraagtype } from './vraagtype.enum';
import { Controltype } from './controltype.enum';
import { Condition } from '@models/vragenboom';
import { ControlParameter } from './control-parameter';

export class Vraag {
  public constructor(init?: Partial<Vraag>) {
    this.antwoorden = [];
    Object.assign(this, init);
  }

  id: string;
  titel: string;
  titel_toevoeging: string;
  vraagregels: string[];
  vraag_bullets: string[];
  vraagtype: Vraagtype;
  control: Controltype;
  verplicht: boolean;
  startvraag: boolean;
  eindvraag: boolean;
  tonen: boolean;
  groep_id: string;
  groep_titel: string;
  referentieDataId: string;
  stappenplan_detail: string;
  stappenplan_stappen: string;
  huidige_stap: string;
  get icon(): string {
    return this.stappenplan_stappen;
  }
  linkt_naar: string;
  aliassen: string[];
  antwoorden: Antwoord[];
  validatieParameters: ValidatieParameter[];
  controlParameters: ControlParameter[];

  connectedVragen: Vraag[];
  messageVraag: Vraag;
  button_text: string;
  button_link: string;
  link_text: string;

  conditions: Condition[];
  styles: string[];
}
